import { CDR_ACK_STATUS, type CdrAckStatus } from "./cdr-constants";

export type CdrIntegrationAck = {
  transfer_type: string;
  status: CdrAckStatus | null;
  motivation: string | null;
};

export function integrationAcksComplete(acks: CdrIntegrationAck[]): boolean {
  return acks.every(
    (a) =>
      a.status === CDR_ACK_STATUS.INFORMED ||
      (a.status === CDR_ACK_STATUS.NOT_INFORMED &&
        typeof a.motivation === "string" &&
        a.motivation.trim() !== ""),
  );
}
